import { PaginatedResource } from '../../typings/Paginated';
import { BaseService, GenericPaginatedParameters, Unauthorized, UnexpectedError } from './base-service';

interface ReportAbuseParams {
    name?: string;
    phone?: string;
    description: string;
    anonymous?: boolean;
}

class AbuseReportService extends BaseService {
    async reportAbuse({ name, phone, description, anonymous }: ReportAbuseParams) {
        let token: string | null = null;

        if (!anonymous) {
            token = await this.getToken();
        }

        const res = await fetch(`${this.centralEndpoint}/abuse-report`, {
            method: 'POST',
            body: JSON.stringify({ name, phone, description }),
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (!res.ok) {
            throw new UnexpectedError();
        }
    }

    async getAbuseReports(params: GenericPaginatedParameters): Promise<PaginatedResource<AbuseReport>> {
        const token = await this.getToken();

        const res = await fetch(`${this.centralEndpoint}/abuse-reports${this.encodeQueryParams({ ...params })}`, {
            method: 'GET',
            headers: this.getHeaders(token, 'application/json;charset=utf-8')
        });

        if (res.status == 401) {
            throw new Unauthorized();
        }

        if (res.status != 200) {
            throw new UnexpectedError();
        }

        return res.json();
    }

    async markAsResolved({ id, commentary }: { id: number; commentary: string; }) {
        const token = await this.getToken();

        const res = await fetch(`${this.centralEndpoint}/abuse-report/${id}/resolve`, {
            method: 'PATCH',
            body: JSON.stringify({ commentary }),
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (!res.ok) {
            throw new UnexpectedError();
        }
    }

    async markAsRejected({ id, commentary }: { id: number; commentary: string; }) {
        const token = await this.getToken();

        const res = await fetch(`${this.centralEndpoint}/abuse-report/${id}/reject`, {
            method: 'PATCH',
            body: JSON.stringify({ commentary }),
            headers: this.getHeaders(token, 'application/json;charset=utf-8'),
        });

        if (!res.ok) {
            throw new UnexpectedError();
        }
    }
}

export const abuseReportService = new AbuseReportService();
